/**
 * Maps a Godot Control `type` to its native (WebGL canvas) painter, the 2D-UI
 * twin of NodeComponentRegistry (ADR-0002). It is separate, so the 3D registry
 * stays THREE-typed, and both share `createTypeRegistry`.
 */
import { createTypeRegistry } from '../../core/createTypeRegistry';
class ControlComponentRegistryImpl {
    registry = createTypeRegistry('ControlComponentRegistry');
    // Data on the registration, not a `node.type` test in the generic walker, as
    // `NodeComponentRegistry` does for `canvasItem`, `container` and `csgShape`.
    childWrappingTypes = new Set();
    register(registration) {
        this.registry.register(registration.typeName, registration.Component);
        if (registration.wrapsChildren) {
            this.childWrappingTypes.add(registration.typeName);
        }
    }
    /** The registered native (WebGL canvas) painter, or undefined until a slice ships one. */
    get(typeName) {
        return this.registry.get(typeName);
    }
    /** Whether this type's native painter takes its children rather than the walker placing them. */
    wrapsChildren(typeName) {
        return this.childWrappingTypes.has(typeName);
    }
    has(typeName) {
        return this.registry.has(typeName);
    }
    getAllTypeNames() {
        return this.registry.getAllTypeNames();
    }
    clear() {
        this.registry.clear();
        this.childWrappingTypes.clear();
    }
}
export const controlComponentRegistry = new ControlComponentRegistryImpl();
//# sourceMappingURL=ControlComponentRegistry.js.map